import { initialPropsExperimentConfig } from '@retail/funnel-components';

/**
 * @type {import('@retail/funnel-components/types/buildConfig/types').ICarleadCreationAppConfig}
 */
export const funnelOptions = {
  redirectOnSuccessUrl: '/booking/{hash}/',
  featuresFlags: {
    redirectToSelfEvaluation: true,
    unspecifiedExperiment: true,
    dropOffEmailDelayInMinutes: 10,
    exactMileage: true,
  },
  trackLandingPageType: 'lead',
  abExperiment: initialPropsExperimentConfig.carleadCreation,
  minimumMileage: true,
  marketingAttributes: {
    'lead-conversational-lead-toggle': 0,
  },
};
